import { exportEntitiesCSV } from 'services/verticalsTablesApi'
import { downloadCSV } from 'utils/downloadCSV'

export const onCSVExport = async (
  zoneEndpoint: string,
  source: { includes: string[] },
  type: string,
  csvFileName: string,
  searchValue: string,
  trackEvent?: (event: { category: string; action: string }) => void,
  selectedIds?: string[],
  sorting?: {
    desc: boolean
    id: string
  }[],
): Promise<void> => {
  try {
    let entityCSV

    if (selectedIds && selectedIds.length > 0) {
      entityCSV = await exportEntitiesCSV(zoneEndpoint, source, type, selectedIds)
    } else {
      entityCSV = await exportEntitiesCSV(zoneEndpoint, source, type, undefined, searchValue, sorting)
    }

    downloadCSV(entityCSV, csvFileName)
    trackEvent?.({ category: 'Export', action: 'User requested for entity CSV' })
  } catch (error) {
    console.error('Error exporting CSV:', error)
    throw error
  }
}
